export const FORM_FIELDS_NAMES = {
	DIAGNOSES_NAME: 'diagnosesName',
	ONSET_DATE: 'onsetDate',
	STATUS: 'status',
	TYPE: 'type',
	NOTE: 'note',
};
